import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import Helmet from 'react-helmet';

function SharedHeadTitleTagComponent({ metadata }) {
    return <Helmet title={metadata.title} />;
}

SharedHeadTitleTagComponent.propTypes = {
    metadata: PropTypes.object.isRequired,
};

export const SharedHeadTitleTag = createFragmentContainer(SharedHeadTitleTagComponent, {
    metadata: graphql`
        fragment SharedHeadTitleTag_metadata on MetaData {
            title
        }
    `,
});
